const React = require("react");
const T = require("prop-types");
const GridList = require("material-ui/GridList").default;
const GridTile = require("material-ui/GridList").GridTile;
const { RadioButton, RadioButtonGroup } = require("material-ui/RadioButton");
const Subheader = require("material-ui/Subheader").default;
const NavLink = require("react-router-dom").NavLink;
const { previewImageLink } = require("utils/asset-api");

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

internals.styles = {
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around"
    },
    gridList: {
        overflowY: "auto"
    },
    gridMeasurements: {
        position: "absolute",
        top: 80,
        right: 0,
        backgroundColor: "rgba(0,0,0,0.21)",
        padding: 10
    }
};

internals.reorderMeasurements = measurements => {
    // Ordering of measurements more intuitive for reviewing
    // and evaluating output
    const tripSchema = [
        "units",
        "height",
        "neckLength",
        "shoulderWidth",
        "inseam",
        "outseam",
        "armLength",
        "waistLengthBack",
        "waistLengthFront",
        "waistToHip",
        "END_OF_LENGTHS",
        "neckCircumference",
        "highBust",
        "fullBust",
        "underBust",
        "waistCircumference",
        "highHipCircumference",
        "fullHipCircumference",
        "thighCircumference",
        "calfCircumference",
        "bicepCircumference",
        "forearmCircumference"
    ];

    const reorderedMeasurementsDisplay = {};

    tripSchema.forEach(measurementKey => {
        // hack to place a divider between Lenghts and Circumferences, which makes the measurements display more readable
        if (measurementKey === "END_OF_LENGTHS") {
            reorderedMeasurementsDisplay.lengthsCircumDivider = true;
            return;
        }

        reorderedMeasurementsDisplay[measurementKey] =
            measurements[measurementKey];
    });

    return reorderedMeasurementsDisplay;
};

module.exports = class RenderTest extends React.Component {
    static propTypes = {
        token: T.string.isRequired,
        list: T.object.isRequired,
        fetchData: T.func.isRequired
    };

    state = {
        openMeasurements: [],
        modelView: "front",
        modelPose: "armsDown"
    };

    componentDidMount() {
        this.props.fetchData();
        window.scrollTo(0, 0);
    }

    _changeView(ev) {
        this.setState({ modelView: ev.currentTarget.value });
    }

    _changePose(ev) {
        this.setState({ modelPose: ev.currentTarget.value });
    }

    changeView = this._changeView.bind(this);
    changePose = this._changePose.bind(this);

    render() {
        const { list } = this.props;

        return (
            <div style={internals.styles.root}>
                <GridList
                    cellHeight={"auto"}
                    cols={2}
                    style={internals.styles.gridList}
                >
                    <Subheader>Render Test</Subheader>
                    <Subheader>Updated on 9/19/2019</Subheader>
                    <Subheader>
                        Change preview image view
                        <RadioButtonGroup
                            name={"view-options"}
                            valueSelected={this.state.modelView}
                            onChange={this.changeView}
                            style={{
                                marginTop: "30px",
                                display: "block",
                                width: "100%"
                            }}
                        >
                            <RadioButton
                                key={"front"}
                                value={"front"}
                                label={"Front"}
                                style={{
                                    display: "inline-block",
                                    width: "150px"
                                }}
                            />
                            <RadioButton
                                key={"back"}
                                value={"back"}
                                label={"Back"}
                                style={{
                                    display: "inline-block",
                                    width: "150px"
                                }}
                            />
                        </RadioButtonGroup>
                        <RadioButtonGroup
                            name={"pose-options"}
                            valueSelected={this.state.modelPose}
                            onChange={this.changePose}
                            style={{
                                marginTop: "30px",
                                display: "block",
                                width: "100%"
                            }}
                        >
                            <RadioButton
                                key={"armsDown"}
                                value={"armsDown"}
                                label={"Arms Down"}
                                style={{
                                    display: "inline-block",
                                    width: "150px"
                                }}
                            />
                            <RadioButton
                                key={"handOnHip"}
                                value={"handOnHip"}
                                label={"Hand On Hip"}
                                style={{
                                    display: "inline-block",
                                    width: "150px"
                                }}
                            />
                        </RadioButtonGroup>
                    </Subheader>
                    {Object.keys(list).map(key => (
                        <GridTile
                            key={list[key].id}
                            title={list[key].title}
                            containerElement={
                                <NavLink to={`/body-model/${list[key].id}`} />
                            }
                            titlePosition="top"
                        >
                            <img
                                width={300}
                                height={650}
                                src={`${previewImageLink(
                                    list[key],
                                    "draft",
                                    this.props.token
                                )}&view=${this.state.modelView}&pose=${
                                    this.state.modelPose
                                }`}
                            />
                            <div style={internals.styles.gridMeasurements}>
                                {Object.keys(
                                    internals.reorderMeasurements(
                                        list[key].measurements
                                    )
                                ).map(mKey => {
                                    if (mKey !== "flags") {
                                        if (mKey === "lengthsCircumDivider") {
                                            return (
                                                <div>
                                                    <hr />
                                                </div>
                                            );
                                        }

                                        return (
                                            <div>
                                                {mKey} -{" "}
                                                {list[key].measurements[mKey]}
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </GridTile>
                    ))}
                </GridList>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/render-test/components/RenderTest.js